import {Button, ButtonProps, useListContext, useUnselectAll, useUpdateMany,} from "react-admin";
import VisibilityIcon from "@material-ui/icons/Visibility";

export const ShowButton = (props: ButtonProps) => {
  const { selectedIds, refetch } = useListContext();
  const unselect = useUnselectAll("deliveries");
  const [update] = useUpdateMany("deliveries", selectedIds, { hide: false });
  const handleSubmit = () => {
    update();
    unselect();
    refetch();
  };

  return (
    <Button
      {...props}
      disabled={selectedIds.length <= 0}
      label="Mostra"
      onClick={handleSubmit}
    >
      <VisibilityIcon />
    </Button>
  );
};
